/**
 * Single place for the business details shown on the public policy pages,
 * the Contact Us page and the pricing page.
 *
 * Every value wrapped in [OWNER TO CONFIRM: ...] is a deliberate placeholder.
 * The owner must replace each one before this ships to production; see
 * docs/hotfix/2026-10-31-razorpay-policies-pricing-APPROVALS.md.
 * Razorpay compares the legal name, address and phone shown on the website
 * with the KYC documents (PAN / Udyam / bank account), so these must match them
 * exactly. Do not guess them.
 */
export const OWNER_TO_CONFIRM_PREFIX = '[OWNER TO CONFIRM';

export const BUSINESS_DETAILS = {
  /** Brand / trade name used across the site. */
  tradeName: 'InviteCloud',
  /** Exact legal name as it appears on PAN / Udyam / bank account (Razorpay KYC). */
  /** Owner decision 2026-10-31: the legal/business name shown on the site is "InviteCloud" (sole proprietorship under Udyam, not GST registered). */
  legalName: 'InviteCloud',
  /** Registered office: the Udyam registration address (owner-confirmed 2026-10-31). Used for KYC and legal references. */
  registeredAddress: 'Dafai No 1, Near Jamma Majid, Shivji Nagar, Majri Colliery, Majri, Chandrapur, Maharashtra 442503',
  /**
   * Operating address shown to customers (Contact Us). Taken from develop's contact page;
   * the owner still needs to confirm the exact street / building line.
   */
  operatingAddress: '3, Vishal Nagar, Pimple Nilakh, Pune, Maharashtra 411027',
  /** A working support phone number. */
  /** Owner 2026-10-31: no phone on the site for now; will be added later. Leave empty to hide the Phone line. */
  supportPhone: '' as string,
  /** Support hours, in IST. Owner-confirmed 2026-10-31. */
  businessHours: 'Monday to Saturday, 10:00 to 18:00 IST',
  supportEmail: 'support@invitecloud.in',
  /** Grievance officer (Consumer Protection (E-Commerce) Rules, 2020, Rule 4). Owner-confirmed 2026-10-31. */
  grievanceOfficerName: 'Apeksha Madavi',
  grievanceOfficerDesignation: 'Founder',
  grievanceEmail: 'founder@invitecloud.in',
  website: 'https://invitecloud.in',
} as const;

/**
 * Refund rules that need an owner decision before they are final.
 * The pack refund window is 7 days, matching develop's WALLET_CREDIT_REFUND_WINDOW_DAYS
 * (InviteCloudBackend/src/modules/billing/domain/refund-window.ts, D-23); owner decision 2026-10-31.
 */
export const REFUND_TERMS = {
  packRefundWindow: '7 days',
  /** Razorpay normal refunds reach the source in 5–7 working days. */
  bankCreditWorkingDays: '5–7 working days',
  /** Payment problems (duplicate, failed, unauthorised) should be reported within this time. */
  paymentIssueReportWindow: '3 working days',
} as const;

/** Where the primary database is hosted. Owner-confirmed 2026-10-31: database migrated to Azure Central India (off Neon Singapore); app servers on DigitalOcean Bangalore. Site names the country only, not vendors (owner 2026-10-31). */
export const DATA_REGION_STATEMENT = 'India';
